<div class="ha-how-you-move-section section-wrapper">
	<div id="lifestyle-how-you-move">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-move.heading'">How You Move</span>
		</div>

		<div class="form-group" [formGroup]="howYouMoveForm">
			<div class="slider-group">
				<div class="form-field slider-group-with-label">
					<div class="radio-btn-label">
						<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-move.form-fields.hoursSitting'"
							>On average, how many hours per day do you spend sitting?</span
						>
					</div>

					<div class="slider">
						<div class="slider-labels">
							<span class="label-left">{{ getHoursSittingValue(howYouMoveForm.get('hoursSitting').value) }} hours</span>
							<span class="label-right">{{ hoursLookupValues[hoursLookupValues.length - 1] }} hours</span>
						</div>
						<mat-slider
							[disabled]="readOnly"
							[max]="hoursSittingSlider.max"
							[min]="hoursSittingSlider.min"
							[step]="hoursSittingSlider.step"
							[showTickMarks]="true">
							<input matSliderThumb formControlName="hoursSitting" />
						</mat-slider>
					</div>
				</div>

				<div class="form-field slider-group-with-label">
					<div class="radio-btn-label">
						<span
							[translate]="
								'wellness.health-assessment-new.lifestyle.how-you-move.form-fields.moderateExercisesMinutes'
							">
							How many minutes per week do you engage in moderate exercise (such as brisk walking or enough movement to
							break a light sweat)
						</span>
					</div>

					<div class="slider">
						<div class="slider-labels">
							<span class="label-left"
								>{{ getMinutesValue(howYouMoveForm.get('moderateExercisesMinutes').value) }}
								{{
									getMinutesValue(howYouMoveForm.get('moderateExercisesMinutes').value).length > 1 ? 'mins' : 'min'
								}}</span
							>
							<span class="label-right">{{ minutesLookupValues[minutesLookupValues.length - 1] }} mins</span>
						</div>
						<mat-slider
							[disabled]="readOnly"
							[max]="minutesSlider.max"
							[min]="minutesSlider.min"
							[step]="minutesSlider.step"
							[showTickMarks]="true">
							<input matSliderThumb formControlName="moderateExercisesMinutes" />
						</mat-slider>
					</div>
				</div>
			</div>
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.lifestyle.how-you-move.form-fields.pastExperience'">
				Please indicate if you have experienced any aches, pains, discomfort or numbness in the following areas in the
				last year?
			</div>
			<div class="checkbox-list" *ngFor="let condition of painDiscomfortResponsesLookup">
				<mat-checkbox
					[disabled]="readOnly"
					appAutofocus
					(change)="conditionSelection(condition)"
					[checked]="condition.checked"
					>{{ condition.name }}</mat-checkbox
				>
			</div>

			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.how-you-move.form-fields.preventingExerciseDays'">
					During the last 7 days, have you been prevented from carrying out normal activities (e.g. job, housework,
					hobbies)
				</div>
				<mat-radio-group
					formControlName="preventingExerciseDays"
					[disabled]="readOnly"
					[(ngModel)]="howYouMoveData.preventingExerciseDays">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-move.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-move.form-fields.option-no'">No</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button class="button button-medium" mat-button>
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
